module.exports = __webpack_public_path__ + "static/img/ltk_logo_black.b18abb6c.png";